/**
 * Schema of ConfigAlerta
 * @author Simpli CLI generator
 */
import {Schema, datetime} from 'simpli-web-sdk'
import DeliveryTrackingResponse from '@/model/response/DeliveryTrackingResponse'
import moment from 'moment'

export default (model: DeliveryTrackingResponse): Schema => ({

    nome: {
        content: model.nome,
    },

    primeiraData: {
        content: datetime(model.primeiraData),
        textContent: datetime(model.primeiraData),
    },

    ultimaData: {
        content: datetime(model.ultimaData),
        textContent: datetime(model.ultimaData),
    },

})
